import React, { Component } from 'react';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import BuildSettings from '../../buildSettings';
import HistoryUtil from '../../common/historyUtil';
import CognitoUtil from '../../aws/cognito/cognitoUtil';
import Events from '../../common/events';
import { strings } from '../../../localization';

export default class FinalizeInvitationPage extends Component {
    
    componentDidMount() {
        if(!this.props.pendingInvite){
            HistoryUtil.push('/');
        }

        this.createKloudUser();
    }

    getStage = (callback) => {
        const stage = this.props.user?.stage;
        if (stage) {
            callback(stage);
        } else {
            CognitoUtil.getUserLinkedRavenStage(
                (retrievedStage) => callback(retrievedStage),
                () => callback(null) // Return null if there's an error
            );
        }
    };

    createKloudUser = () => {
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.finalizing_your_raven_Account, override: true } }));
        
        this.getStage((stage) => {
            LambdaUtil.createKloudUser(
                stage,
                this.props.pendingInvite.inviteEmail,
                this.props.pendingInvite.driverName,
                this.onCreateKloudUserSuccess,
                this.onCreateKloudUserFail
            );
        });
    }

    
    onCreateKloudUserFail = (error) => {
        
        // This is probably because the call to createKloudUser failed because the user is not signed in
        // Lambda function only work with a signed in user (authenticated user)
        if(!error) {
            console.error("FinalizeInvitationPage createKloudUserFail: error is null");
            window.location.href = '/?error=timeout';
            return;
        }

        // Raven Account already exists for this cognito user
        // This could happen if the invitation process has been interrupted between the time the raven account was created and the invitation was accepted
        // In this case, we should just accept the invitation
        if(error.errorCode === 4005) {
            this.acceptInvitation();
            return;
        }

        console.error("FinalizeInvitationPage createKloudUserFail", error);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        window.location.href = '/?error=error_create_kloud_user';
    }

    onCreateKloudUserSuccess = (e) => {
        // console.log(e);
        var payload = JSON.parse(e.Payload);

        if (payload && payload.status && payload.status === "ERROR") {
            this.onCreateKloudUserFail(payload);
        } else {
            this.acceptInvitation();
        }
    }

    acceptInvitation = () => {
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.finalizing_your_invitation, override: true } }));

        this.getStage((stage) => {
            const { token, signature } = this.props.pendingInvite;
            LambdaUtil.acceptRavenInvitation(stage, token, signature, this.onAcceptInviteSuccess, this.onAcceptInviteFail);
        });
    }

    
    onAcceptInviteSuccess = (data) => {
        var payload = JSON.parse(data.Payload);

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

        if (payload.status === 'ERROR') {
            this.onAcceptInviteFail(payload);            
        } 
        else {
            
            document.dispatchEvent(Events.showLoading({ style: 'success' }));

            CognitoUtil.clearUserInviteAttribute();
            CognitoUtil.clearUserPendingInvite();

            setTimeout(() => {
                this.proceedToNextStep();
            }, 2000);
        }
    }

    onAcceptInviteFail = (data) => {
        console.error("FinalizeInvitationPage onAcceptInviteFail", data);

        // Invitation is already accepted.
        // This could happen if the invitation process has been interrupted between the time the invitation was accepted and the flags were being cleared from cognito user
        // In this case, we should just clear the flags and proceed
        if (data.errorCode === 7000) {
            CognitoUtil.clearUserInviteAttribute();
            CognitoUtil.clearUserPendingInvite();

            this.proceedToNextStep();

            return;
        }
        
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

        window.location.href = '/?error=error_accept_invite';
    }

    proceedToNextStep = () => {
        if(this.props.pendingInvite.nextStep) {
            HistoryUtil.push(this.props.pendingInvite.nextStep);
            return;
        }

        CognitoUtil.logout();
        HistoryUtil.push('/');
    }

    render() {
        return (
            <div className="finalize-invitation">
            </div>
        );
    }
}